module.exports = __webpack_public_path__ + "static/aa72178ac1977afb4fe3e345b22d9ccf8a8bb09b7597c408dbb603c13f85708d-822fb71616a33abf4896ae133a068b72.jpeg";